// extracted by mini-css-extract-plugin
module.exports = {"cancelButton":"UpdateTemplate_cancelButton__1ixPY"};